import BaseView from './BaseView';
import { gsap } from 'gsap';
import scrollLock from 'scroll-lock';

let view = null;

class Home extends BaseView {
	constructor(container) {
		super(container);
		
		this.handleUserActivity = this.handleUserActivity.bind(this);
		window.addEventListener('mousemove', this.handleUserActivity);
		window.addEventListener('keydown', this.handleUserActivity);
		window.addEventListener('scroll', this.handleUserActivity);

		this.setIdleTimer();
	}
	
	init() {
		this.characters = this.container.querySelectorAll('.title__char');
	
		gsap.set(this.characters, {
			yPercent: 100
		})

		this.nav = this.container.querySelector('[data-nav]');

		gsap.set(this.nav, {
			yPercent: -100,
		})

		this.stickers = this.container.querySelectorAll('[data-sticker]');
		this.stickers.forEach((sticker) => {
			gsap.set(sticker, {
				scale: 0
			})
		})
	}

	animateTitle() {
		scrollLock.disablePageScroll();
		gsap.to(this.characters, {
			yPercent: -12,
			opacity: 1,
			stagger: {
				each: 0.015,
				ease: "sine.inOut"
			},
			duration: 0.3,
			onComplete: () => {
				this.animateNav();
			}
		});
	}

	animateNav() {
		gsap.to(this.nav, {
			yPercent: 0,
			duration: 0.8,
			ease: "power3.out",
		})
		scrollLock.enablePageScroll();
	}
	
	easterEgg() {
		this.stickers.forEach((sticker, index) => {
			gsap.set(sticker, {
				opacity: 1
			}),
			gsap.to(sticker, {
				scale: 1,
				ease: "elastic.out(1,0.3)",
				duration: 1.5,
				delay: 3 * index
			})
		})
	}

	handleUserActivity() {
		gsap.to(this.stickers, {
			duration: 0.5,
			opacity: 0,
			delay: 1,
			onComplete: () => {
				gsap.killTweensOf(this.stickers);
	
				gsap.set(this.stickers, {
					scale: 0,
					opacity: 1
				});
				this.setIdleTimer();
			}
		});
	}
	

	setIdleTimer() {
		if (this.idleTimer) {
			clearTimeout(this.idleTimer);
		}
	
		this.idleTimer = setTimeout(() => {
			this.easterEgg();
		}, 3000);
	}

	destroy() {
		super.destroy();
		window.removeEventListener('mousemove', this.handleUserActivity);
		window.removeEventListener('keydown', this.handleUserActivity);
		window.removeEventListener('scroll', this.handleUserActivity);
		clearTimeout(this.idleTimer);
	}
}

export default {
	namespace: 'home',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Home(next.container);
		view.init();
	},
	afterEnter: ({ current, next, trigger }) => {
		if (!view) {
			return;
		}
		view.animateTitle();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
